import { type IClientResponse, Query } from "@gen/app-query";
import { type AnyRoute, createRoute, redirect } from "@tanstack/react-router";

import { type AuthCtx } from "~/contexts/auth_query";

import { Kyc } from "./Kyc";

export function createKycRoute<P extends AnyRoute>(parent: P) {
  return createRoute({
    getParentRoute: () => parent,
    path: "clients/$clientId/kyc",
    component: Kyc,
    staticData: { isStandalone: true },
    beforeLoad: async ({ params, context }) => {
      const { queryClient, resolveActiveClientId } = context as AuthCtx;
      const { clientId } = params;

      if (resolveActiveClientId(clientId) !== clientId) {
        throw redirect({ to: "/", replace: true });
      }

      const client: IClientResponse = await queryClient.ensureQueryData({
        queryKey: Query.core_getClientQueryKey(clientId),
        queryFn: () => Query.Client().core_getClient(clientId),
      });

      if (!client?.on_behalf_of_stripe_connected_account_id) {
        throw redirect({
          to: "/clients/$clientId/transactions",
          params: { clientId },
          replace: true,
        });
      }
    },
    head: () => ({
      meta: [{ title: "Account Hub" }],
    }),
  });
}
